<template>
<div class="sideBar">
   <div class="logo">
    <img src="../assets/logo.png" alt="teller logo" width="150" height="40">
  </div>
  <div class="balance">
    <div>
       <h4 class="mb-0 bannl">Available Balance</h4>
         <v-divider></v-divider>
      <h4 class="bannl">Commission Balance</h4> 
    </div>
  
 <div class="cash">
     <h4 class="bannl mb-2"> {{DisplayCurrency(this.Balance/100)}}</h4>
        <v-divider></v-divider>
     <h4 class="bannl"> {{DisplayCurrency(this.commissionBalance/100)}}</h4>
 </div>
  </div>
    <v-card
    dark
    flat
    class="mx-auto card"
  >
  <v-list
  class="list"
        nav
        dense
      >
        <v-list-item-group  v-for="(item, i) in items" :key="i" :class="$route.name  === item.route  ? 'highlighted' : 'pointer'">
          <v-list-item :inactive='true' @click="navigate(item.route)">
            <v-list-item-icon class="iconX">  
             <v-img v-if="$route.name  != item.route" height='24' width='24' :src="item.activeIcon" contain></v-img>
             <v-img v-else max-height='25' max-width='25' :src="item.icon" contain></v-img>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title :class="$route.name  === item.route  ? 'highlighted' : 'pointer'" class="titl"  v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    
    <div class="vertical"/>
      <v-list nav
        dense class="list">
           <v-list-item-group   v-for="(item, i) in lasts" :key="i" :class="$route.name  === item.route  ? 'highlighted' : 'pointer'">
          <v-list-item :inactive='true' @click="navigate(item.route)">
            <v-list-item-icon class="iconX">  
               <v-img v-if="$route.name  != item.route" height='24' width='24' :src="item.activeIcon" contain></v-img>
             <v-img v-else max-height='30' max-width='30' :src="item.icon" contain></v-img>  
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="titl" :class="$route.name  === item.route  ? 'highlighted' : 'pointer'"  v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>  
      <div class="list2">
       <Logout/>
      </div>
    </v-list>
  </v-card>
  </div>
</template>

<script>
import currencyFormatter from 'currency-formatter'
import Logout from '../pages/LogOut'
export default {
  components:{
    Logout
  },
      data: () => ({
      item: 0,
      items: [
        { text: 'Home', icon: require('../assets/iconshome.png'), activeIcon: require('../assets/whome.png'), route: "dashboard" },
        { text: 'Transfer', icon: require('../assets/bx_bx-transfer-alt.png'),activeIcon: require('../assets/wtransfer.png'),route: "transfer"  },
        { text: 'Pay Bills', icon: require('../assets/ri_secure-payment-line.png'),activeIcon: require('../assets/wpayment.png'),route: "paybills"  },
        { text: 'Transaction History', icon: require('../assets/ic_sharp-history.png'),activeIcon: require('../assets/whistory.png'),route: "transactionHistory"  },
      ],
      lasts:[
        { text: 'Change Pin', icon: require('../assets/ri_lock-password-line.png'),activeIcon: require('../assets/wpin.png'),route: "changepin"  },
        { text: 'Customer Service', icon: require('../assets/ri_customer-service-line.png'),activeIcon: require('../assets/customer-service-line.png'),route: "CustomerServices"  },
      ]
    }),
    computed: {
       Balance () {
        return this.$store.getters.getBalance
    },
    commissionBalance(){
        return this.$store.getters.getCommissionBalance
    }
    }, 
      methods: {
      navigate(to){
        this.$router.push({name: to})
      },
      DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    },
}
</script>

<style scoped>

.sideBar{
  grid-area: sideBar;
  background-image: linear-gradient(to bottom, #9f09d7,  #bd2427);
}
.panel{
  grid-area: panel;
   background-color: yellow;
}
.logo{
    margin-left: 20px;
    margin-top: 15px;
    padding: 5px;
    width: 180px;
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
    background-color: white;
}
.bann{
  display: flex;
}
.balance{
display: flex;
justify-content: center;
align-items:center;
min-height: 70px;
padding-left: 20px;
margin-top: 30px;
margin-bottom: 10px;
padding-top: 10px;
background-color: white;   
}
.balance h4{
    color: #ad1684;
    font-size: 20px;
}
.card{
    background-color: transparent !important;
    margin-right: 30px !important;
}
.list{
  background-color: transparent !important;  
  margin-left: 20px;
}
.list2{
 margin-top: 150px;
}
.iconX{
   margin-right: 25px;
}
.pointer :hover {
  cursor: pointer;
  border-radius: 5px;
}
.highlighted {
  background-color: #fff;
  color: white;
   border-radius: 5px;
}
.maf{
    height: 20px;
    width: 20px;
}

.vertical{
    display: flex;
    flex: 1;
    height: 1px;
    background-color: white;
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;

}
.pointer :hover {
  cursor: pointer;
  background-color: rgba(179, 1, 245, 1)!important;
}
.highlighted {
  background-color: #fff !important;
  color: #ad1684;
}
.Logout{
    margin-top: 150px;
    display: flex;
    align-items: flex-end;
}
.titl{
  font-family: 'AvenirLTProBook';
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.cash{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  padding:10px;
}
.bannl{
  font-family: 'AvenirLTProHeavy';
  font-size: 15px !important;
  font-weight: 500 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  letter-spacing: normal !important;
  color: #ad1684;
  text-overflow: ellipsis !important;
  overflow: hidden !important; 
}
h6{
  font-family: 'AvenirLTProHeavy';
  font-size: 14px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.92;
  letter-spacing: normal;
  color: #ad1684;
}
small{
  height: 22px;
  font-family: 'AvenirLTProBook';
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: #000000;
}

</style>